import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Traceability Matrix',
      type: 'table',
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'requirements',
                },
              },
              subqueries: {
                requirements: {
                  filter: {
                    or: [
                      { '=': [{ '`': { '``': { '@$': 'projectId' } } }, null] },
                      {
                        '=': [
                          { '@': 'specProject' },
                          {
                            '@>': [
                              { '`': { '``': { '@$': 'projectId' } } },
                              'recordId',
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!requirements:!requirement',
                  subqueries: {
                    specProject: {
                      ref: {
                        attr: 'attr:ent#!requirements#!requirement:!spec',
                      },
                      target: 'ent:!specs:!spec',
                      selection: {
                        '@.': ['!project', { ref: { entity: '!proj' } }],
                      },
                    },
                  },
                },
              },
            },
          },
          query: {
            '`': {
              filter: {
                or: [
                  { '=': [{ '`': { '``': { '@$': 'projectId' } } }, null] },
                  {
                    '=': [
                      { '@': 'specProject' },
                      {
                        '@>': [
                          { '`': { '``': { '@$': 'projectId' } } },
                          'recordId',
                        ],
                      },
                    ],
                  },
                ],
              },
              sort: {
                by: {
                  '@.': '!id',
                },
              },
              target: 'ent:!requirements:!requirement',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      requirement: {
                        '{}': {
                          value: {
                            '@.': '!id',
                          },
                        },
                      },
                      spec: {
                        '{}': {
                          value: {
                            '@': 'specId',
                          },
                        },
                      },
                      verifyMethod: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '@.': '!verify',
                              },
                              'unspecified',
                            ],
                          },
                        },
                      },
                      priority: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '@.': '!priority',
                              },
                              'unspecified',
                            ],
                          },
                        },
                      },
                      state: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'specApprovedAt',
                                    },
                                    null,
                                  ],
                                },
                                'Awaiting Approval',
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'buildLinks',
                                    },
                                    null,
                                  ],
                                },
                                'Orphaned',
                              ],
                              [
                                {
                                  '!=': [
                                    {
                                      '@': 'failingLinks',
                                    },
                                    null,
                                  ],
                                },
                                'Partial',
                              ],
                              [
                                {
                                  '!=': [
                                    {
                                      '@': 'passingLinks',
                                    },
                                    null,
                                  ],
                                },
                                'Covered',
                              ],
                              'Unverified',
                            ],
                          },
                        },
                      },
                      jiraStatus: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '@.': '!jira_status',
                              },
                              'unknown',
                            ],
                          },
                        },
                      },
                      pullRequests: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '#': {
                                  '@': 'buildLinks',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      pullRequestsPassing: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '#': {
                                  '@': 'passingLinks',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      pullRequestsFailing: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '#': {
                                  '@': 'failingLinks',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                    },
                  },
                  overflowActions: {
                    '[]': [
                      {
                        '{}': {
                          icon: 'atn-icon atn-link',
                          name: 'View Requirement Details',
                          action: {
                            '{}': {
                              payload: {
                                '{}': {
                                  goto: {
                                    '{}': {
                                      variables: {
                                        '{}': {
                                          reqID: {
                                            '@.': '!id',
                                          },
                                        },
                                      },
                                      navigationId: 'requirement.details',
                                    },
                                  },
                                },
                              },
                              operation: 'ui.navigate',
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
              subqueries: {
                specProject: {
                  ref: { attr: 'attr:ent#!requirements#!requirement:!spec' },
                  target: 'ent:!specs:!spec',
                  selection: {
                    '@.': ['!project', { ref: { entity: '!proj' } }],
                  },
                },
                specId: {
                  ref: {
                    attr: 'attr:ent#!requirements#!requirement:!spec',
                  },
                  target: 'ent:!specs:!spec',
                  quantity: 1,
                  selection: {
                    '@.': '!id',
                  },
                },
                specApprovedAt: {
                  ref: {
                    attr: 'attr:ent#!requirements#!requirement:!spec',
                  },
                  target: 'ent:!specs:!spec',
                  quantity: 1,
                  selection: {
                    '@': 'approvalMergedAt',
                  },
                  subqueries: {
                    approvalMergedAt: {
                      ref: {
                        attr: 'attr:ent#!specs#!spec:!approval_pull_request',
                      },
                      target: 'ent:!pull_requests:!pull_request',
                      selection: {
                        '@.': '!merged_at',
                      },
                    },
                  },
                },
                buildLinks: {
                  ref: {
                    attr: 'attr:ent#!pr_req_links#!pr_req_link:!requirement',
                  },
                  target: 'ent:!pr_req_links:!pr_req_link',
                  selection: {
                    '@.': '!id',
                  },
                },
                failingLinks: {
                  ref: {
                    attr: 'attr:ent#!pr_req_links#!pr_req_link:!requirement',
                  },
                  target: 'ent:!pr_req_links:!pr_req_link',
                  filter: {
                    '=': [
                      {
                        '@': 'testOutcome',
                      },
                      'FAIL',
                    ],
                  },
                  selection: {
                    '@.': '!id',
                  },
                  subqueries: {
                    testOutcome: {
                      ref: {
                        attr: 'attr:ent#!pr_req_links#!pr_req_link:!pull_request',
                      },
                      target: 'ent:!pull_requests:!pull_request',
                      selection: {
                        '@': 'result',
                      },
                      subqueries: {
                        result: {
                          ref: {
                            attr: 'attr:ent#!results#!result:!pull_request',
                          },
                          target: 'ent:!results:!result',
                          quantity: 1,
                          selection: {
                            '@.': '!test_outcome',
                          },
                        },
                      },
                    },
                  },
                },
                passingLinks: {
                  ref: {
                    attr: 'attr:ent#!pr_req_links#!pr_req_link:!requirement',
                  },
                  target: 'ent:!pr_req_links:!pr_req_link',
                  filter: {
                    '=': [
                      {
                        '@': 'testOutcome',
                      },
                      'PASS',
                    ],
                  },
                  selection: {
                    '@.': '!id',
                  },
                  subqueries: {
                    testOutcome: {
                      ref: {
                        attr: 'attr:ent#!pr_req_links#!pr_req_link:!pull_request',
                      },
                      target: 'ent:!pull_requests:!pull_request',
                      selection: {
                        '@': 'result',
                      },
                      subqueries: {
                        result: {
                          ref: {
                            attr: 'attr:ent#!results#!result:!pull_request',
                          },
                          target: 'ent:!results:!result',
                          quantity: 1,
                          selection: {
                            '@.': '!test_outcome',
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'requirement',
                  direct: {
                    '{}': {
                      name: 'Requirement',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'spec',
                  direct: {
                    '{}': {
                      name: 'Spec',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'verifyMethod',
                  direct: {
                    '{}': {
                      name: 'Verify Method',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'priority',
                  direct: {
                    '{}': {
                      name: 'Priority',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'state',
                  direct: {
                    '{}': {
                      name: 'State',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'jiraStatus',
                  direct: {
                    '{}': {
                      name: 'Jira Status',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'pullRequests',
                  direct: {
                    '{}': {
                      name: 'Pull Requests',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'pullRequestsPassing',
                  direct: {
                    '{}': {
                      name: 'PRs Passing',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'pullRequestsFailing',
                  direct: {
                    '{}': {
                      name: 'PRs Failing',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
            ],
          },
        },
      },
    },
  },
}
